import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function IntroCurtain() {
  const [visible, setVisible] = useState(true);
  const [splitOpen, setSplitOpen] = useState(false);
  useEffect(() => {
    // Block body scroll while curtain is visible
    document.body.style.overflow = 'hidden';
    // Start the split animation after logo is visible
    const splitTimer = setTimeout(() => {
      setSplitOpen(true);
    }, 1200);
    // Remove curtain from DOM after animation completes
    const hideTimer = setTimeout(() => {
      setVisible(false);
      document.body.style.overflow = '';
    }, 2400);
    return () => {
      clearTimeout(splitTimer);
      clearTimeout(hideTimer);
      document.body.style.overflow = '';
    };
  }, []);
  return <AnimatePresence data-id="element-330" data-mp="2hmpqyxvn30h9">
      {visible && <div className="fixed inset-0 z-[200] pointer-events-none" data-id="element-331" data-mp="2hkweh1ychm1c">
          {/* Left panel */}
          <motion.div initial={{
        x: 0
      }} animate={{
        x: splitOpen ? '-100%' : 0
      }} transition={{
        duration: 1.1,
        ease: [0.76, 0, 0.24, 1]
      }} className="absolute top-0 left-0 w-1/2 h-full bg-brand-dark border-r border-brand-gold/30" data-id="element-332" data-mp="2coef6hlsafwe" />
          {/* Right panel */}
          <motion.div initial={{
        x: 0
      }} animate={{
        x: splitOpen ? '100%' : 0
      }} transition={{
        duration: 1.1,
        ease: [0.76, 0, 0.24, 1]
      }} className="absolute top-0 right-0 w-1/2 h-full bg-brand-dark border-l border-brand-gold/30" data-id="element-333" data-mp="1eyr0alnmrv3j" />

          {/* Logo centered */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: splitOpen ? 0 : 1,
        scale: splitOpen ? 0.95 : 1
      }} transition={{
        opacity: {
          duration: splitOpen ? 0.4 : 0.9,
          ease: 'easeOut'
        },
        scale: {
          duration: 1.0,
          ease: 'easeOut'
        }
      }} className="absolute inset-0 flex items-center justify-center" data-id="element-334" data-mp="2cmrad7ita1mb">
            <img src="https://cdn.magicpatterns.com/uploads/d5PCZLxog3stu5Kmdcos9m/tairu_new_1.png" alt="Tairu Aesthetics" className="h-28 md:h-36 w-auto object-contain mix-blend-lighten drop-shadow-[0_0_30px_rgba(184,134,11,0.4)]" data-id="element-335" data-mp="357ocnxws6abs" />
          </motion.div>

          {/* Subtle gold shimmer line down the seam */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: splitOpen ? 0 : 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-full bg-gradient-to-b from-transparent via-brand-gold/60 to-transparent" data-id="element-336" data-mp="2r6by9qx9qgs0" />
        </div>}
    </AnimatePresence>;
}